import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function BrokerPatterns() {
    return (
        <TopicLayout
            title="Queue vs. pub/sub vs. log"
            intro="Three ways a broker can hand a message to consumers: give it to exactly one worker, fan it out to every subscriber, or append it to a durable log that consumers read from at their own pace."
            diagram={
                <Diagram viewBox="0 0 560 210">
                    <text x={95} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Queue</text>
                    <Box x={55} y={25} width={80} height={30} label="Producer"/>
                    <Box x={45} y={90} width={100} height={32} label="Queue" accent/>
                    <Box x={55} y={150} width={80} height={30} label="Worker"/>
                    <Arrow x1={95} y1={55} x2={95} y2={90}/>
                    <Arrow x1={95} y1={122} x2={95} y2={150}/>
                    <text x={95} y={195} textAnchor="middle" fontSize={11} opacity={0.7}>one worker per message</text>

                    <line x1={185} y1={10} x2={185} y2={200} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={285} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Pub/sub</text>
                    <Box x={245} y={25} width={80} height={30} label="Publisher"/>
                    <Box x={235} y={90} width={100} height={32} label="Topic" accent/>
                    <Box x={200} y={150} width={70} height={30} label="Sub A"/>
                    <Box x={290} y={150} width={70} height={30} label="Sub B"/>
                    <Arrow x1={285} y1={55} x2={285} y2={90}/>
                    <Arrow x1={265} y1={122} x2={235} y2={150}/>
                    <Arrow x1={305} y1={122} x2={325} y2={150}/>
                    <text x={285} y={195} textAnchor="middle" fontSize={11} opacity={0.7}>every subscriber gets it</text>

                    <line x1={375} y1={10} x2={375} y2={200} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={475} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Log</text>
                    <Box x={435} y={25} width={80} height={30} label="Producer"/>
                    <Box x={400} y={90} width={150} height={32} label="Log (partitions)" accent/>
                    <Box x={400} y={150} width={70} height={30} label="Reader A"/>
                    <Box x={480} y={150} width={70} height={30} label="Reader B"/>
                    <Arrow x1={475} y1={55} x2={475} y2={90}/>
                    <Arrow x1={440} y1={122} x2={435} y2={150} dashed muted/>
                    <Arrow x1={510} y1={122} x2={515} y2={150} dashed muted/>
                    <text x={475} y={195} textAnchor="middle" fontSize={11} opacity={0.7}>each reader keeps its own offset</text>
                </Diagram>
            }
            useWhen={[
                'Queue: workers compete to process tasks, with one successful handler desired per task.',
                'Pub/sub: several independent subscribers should each react to the same event.',
                'Log: consumers need durable history, independent offsets, replay or high-throughput stream processing.'
            ]}
            tradeOff="Brokers normally provide at-least-once or at-most-once delivery modes, not magic exactly-once side effects, so consumers should be idempotent. Pub/sub fan-out needs per-subscriber failure handling. Logs retain events for replay, but ordering is typically guaranteed only within a partition; choosing partition keys trades parallelism against ordering scope."
            ruleOfThumb="Use a queue to distribute work, pub/sub to fan out facts, and a log when retained order and replay matter—then design explicitly for duplicates, poison messages and ordering boundaries."
        />
    )
}
